import { useContext, useEffect, useRef, useState }  from "react";
import GenericTemplate from "../templates/GenericTemplate";
import { Box } from "@material-ui/core";
import ShiftTableHeader from "../conponents/ShiftTableHeader";
import { GlobalContext } from "../globalState";
import * as commonFnc from '../common/commonFnc';
import { DataGrid } from "@mui/x-data-grid";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, useTheme, Button } from "@mui/material";
import '../css/Loading.css';
import '../css/shiftTable.css';
import SP_ShiftTableHeader from "./SP_ShiftTableHeader";
import ChangeShiftPriorityHighIcon from "./parts/ChangeShiftPriorityHighIcon";
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

const ShiftTableContents = (props) =>{
    const {Login_user_info} = props;
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const {serchCondition, setSerchCondition} = useContext(GlobalContext);
    const Env_msts = useContext(GlobalContext).Env_msts;
    const TIME_PAID_HOLIDAY_FLG = Env_msts.find(p => p.env_key === "TIME_PAID_HOLIDAY")?.env_bool;

    const [Department_msts, setDepartment_msts] = useState([]);
    const [Shift_msts, setShift_msts] = useState([]);
    const [Users, setUsers] = useState([]);
    const [kintaiList, setKintaiList] = useState([]);
    const [shiftTableSeq, setShiftTableSeq] = useState([]);

    const [shiftHash, setShiftHash] = useState([]);
    const [shiftStyleList, setShiftStyleList] = useState([]);
    const [userHash, setUserHash] = useState([]);
    const [deptHash, setDeptHash] = useState([]);
    
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);

    const [holidays, setHolidays] = useState({});
    
    const [isViewDept, setIsViewDept] = useState(false);
    const [isViewPaidHoliday, setIsViewPaidHoliday] = useState(false);

    // 行選択機能のための状態
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    // 変更フラグを追加
    const [hasChanges, setHasChanges] = useState(false);

    const [elements, setElements] = useState(TIME_PAID_HOLIDAY_FLG?['shift_type_cd','harf_holiday_shift_type_cd','paid_holiday_shift_type_cd']:['shift_type_cd','harf_holiday_shift_type_cd']);

    const printDateTimeRef = useRef(null);

    useEffect(()=>{
        const pageStyle = document.createElement('style');
        pageStyle.setAttribute('data-shift-print-page', 'true');

        const handleBeforePrint = () => {
            if (printDateTimeRef.current) {
                printDateTimeRef.current.textContent = `印刷日時：${commonFnc.formatTimestamp(new Date())}`;
            }
            // 勤務カレンダーの @page（A4縦）を上書きしないよう、シフト印刷時だけ横向きを注入する
            pageStyle.textContent = '@page { size: A4 landscape; margin: 8mm; }';
            if (!pageStyle.isConnected) {
                document.head.appendChild(pageStyle);
            }
        };
        const handleAfterPrint = () => {
            if (pageStyle.isConnected) {
                pageStyle.remove();
            }
        };
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);
        return () => {
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
            if (pageStyle.isConnected) {
                pageStyle.remove();
            }
        };
    }, []);

    

    
    // sort順
    const DEFAULT_EXPORT_SHIFTTABLE_SORT_KEY = Env_msts.find((p)=>p.env_key === "DEFAULT_EXPORT_SHIFTTABLE_SORT_KEY")?.env_value;
    const [sortKey, setSortKey] = useState(DEFAULT_EXPORT_SHIFTTABLE_SORT_KEY||'shift_table_seq'); // shift_table_seq oruser_id or csv_seq

    useEffect(()=>{
        if(isViewPaidHoliday){
            setElements(['shift_type_cd','harf_holiday_shift_type_cd','paid_holiday_shift_type_cd']);
        }else{
            setElements(['shift_type_cd','harf_holiday_shift_type_cd']);
        }

    },[isViewPaidHoliday])

    
    
    useEffect(()=>{
        fetch('https://holidays-jp.github.io/api/v1/date.json')
        .then((res) => res.json())
        .then((data)=>setHolidays(data));
    },[])
    
    // 部署マスタ一覧取得
    const getDepartmentMst = async () =>{
        const res = await fetch("/api/select/department_msts");
        const data = await res.json();
        setDepartment_msts(data);
    }
    // シフトマスタ一覧取得
    const getShiftMst = async ()=>{
        const res = await fetch("/api/select/shift_mst");
        const data  = await res.json();
        setShift_msts(data);   
    }
    // シフトマスタ一覧取得
    const getUsers = async ()=>{
        const res = await fetch("/api/select/users");
        const data  = await res.json();
        setUsers(data);   
    }
    // シフトマスタ一覧取得
    const getShiftTableSeq = async ()=>{
        const res = await fetch("/api/select/shiftTableSeq");
        const data  = await res.json();
        setShiftTableSeq(data);   
    }
    // 全ユーザの1か月の勤怠情報を取得
    const getKintaiList = async () => {
        const query_kintai = new URLSearchParams({
                target_date_from: commonFnc.formatDate(serchCondition.target_date_from),
                target_date_to: commonFnc.formatDate(serchCondition.target_date_to)
            });
        const res = await fetch(`/api/select/allUser_term_kintai_bsc?${query_kintai}`);
        const data = await res.json();
        setKintaiList(data);
    }

    const getShiftTable = async () =>{
        // すべての関数を並行して実行し、それが完了するまで待機する
        await Promise.all([
          getDepartmentMst(),
          getShiftMst(),
          getKintaiList(),
          getUsers(),
          getShiftTableSeq(),
        ]);
        createColumnData();
    }

    useEffect(()=>{
        getDepartmentMst();
        getShiftMst();
        getUsers();
    },[])

    useEffect(()=>{
        createRowData(kintaiList, shiftTableSeq);
    },[kintaiList, sortKey])

    useEffect(()=>{
        createColumnData();
    },[shiftHash])

    useEffect(()=>{
        let tmpShiftHash = {}
        let tmpShiftStyleList = {}
        Shift_msts.map((Shift_mst) => {
            tmpShiftHash[Shift_mst.shift_type_cd] = Shift_mst.shift_name;

            tmpShiftStyleList[Shift_mst.shift_type_cd] = {
                backgroundColor:Shift_mst.backgroundcolor,
                color:Shift_mst.textcolor,
            }

        });
        setShiftHash(tmpShiftHash);
        setShiftStyleList(tmpShiftStyleList);
    },[Shift_msts]);

    
    useEffect(()=>{
        let tmpUserHash = {}
        Users.map((user) => {
            tmpUserHash[user.user_id] = {...user}
        });
        setUserHash(tmpUserHash);
    },[Users]);
    
    useEffect(()=>{
        let tmpDeptHash = {}
        Department_msts.map((dept) => {
            tmpDeptHash[dept.department_cd] = {...dept}
        });
        setDeptHash(tmpDeptHash);
    },[Department_msts]);
    
    useEffect(()=>{
        setSerchCondition({
            ...serchCondition,
            target_deptgr_cd: Login_user_info?.organization_cd, 
            target_dept_cd: Login_user_info?.department_cd,
        })
    },[]);
    


    /**
     * 開始日と終了日を指定して日付配列を作成する。
     * @param {*} startDate 
     * @param {*} endDate 
     * @returns 
     */
    function getDatesBetween(startDate, endDate) {
        let dates = [];
        let currentDate = new Date(startDate);
        
        while (currentDate <= new Date(endDate)) {
            dates.push(commonFnc.formatDate(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }
        
        return dates;
    }

    /**
     * IDごとに日付を横持ちにする。
     * @param {*} data 
     * @returns 
     */
    function transformShiftData(data) {
        const result = {};
        
        const tmpData = serchCondition.target_dept_cd ? data.filter(item=>userHash[item.user_id]?.department_cd === serchCondition.target_dept_cd):data;
        tmpData.forEach(item => {
          const { user_id, date, shift_type_cd, harf_holiday_shift_type_cd, paid_holiday_shift_type_cd, shift_type_cd_change_flg } = item;
          
          // 初めての user_id の場合、空のオブジェクトを作成
          if (!result[user_id]) {
            result[user_id] = { user_id };
            // シフト以外のデータを登録
            result[user_id]["user_name"] = userHash[item.user_id]?.first_name + " " + userHash[item.user_id]?.second_name;
            result[user_id]["organization_cd"] = userHash[item.user_id]?.organization_cd;
            result[user_id]["department_cd"] = userHash[item.user_id]?.department_cd;
            result[user_id]["csv_seq"] = userHash[item.user_id]?.csv_seq;
          }
      
          // 日付をキーにして shift_type_cd を設定
          result[user_id][commonFnc.formatDate(date)] = {
            shift_type_cd:shift_type_cd,
            harf_holiday_shift_type_cd:harf_holiday_shift_type_cd,
            paid_holiday_shift_type_cd:paid_holiday_shift_type_cd,
            shift_type_cd_change_flg:shift_type_cd_change_flg,
          }

        });

      
        // オブジェクトを配列に変換
        return Object.values(result);
      }

    /**
     * user_idごとに指定した項目の合計を求める関数
     * @param {Array} data - {user_id, date, paid_holiday_time} のオブジェクト配列
     * @returns {Object} - user_idごとの paid_holiday_time の合計
     */
    function getTotalItem(data, item) {
        return data.reduce((acc, curr) => {
        // すでにuser_idが存在する場合は加算、存在しない場合は新規作成
        if (acc[curr.user_id]) {
            acc[curr.user_id] += curr[item];
        } else {
            acc[curr.user_id] = curr[item];
        }
        return acc;
        }, {});
    }
    
    /**
     * row情報を作成する。
     * @param {*} kintaiList 
     * @param {*} shiftTableSeq 
     */
    const createRowData = (kintaiList, shiftTableSeq)=>{
        const uniqueUseridList = transformShiftData(kintaiList);
        const publicHolidayTimes = getTotalItem(kintaiList, 'public_holiday_time');
        const paidHolidayTimes = getTotalItem(kintaiList, 'paid_holiday_time');

        const tmpRow = uniqueUseridList.map(user => {

            const seq = shiftTableSeq.find(p=>p.user_id === user.user_id && p.department_cd === user.department_cd)?.seq;
            return {
            ...user,
            total_public_holiday_time: publicHolidayTimes[user.user_id] || 0, // 該当しない場合は0を設定
            total_paid_holiday_time: paidHolidayTimes[user.user_id] || 0, // 該当しない場合は0を設定
            shift_table_seq:seq || 999,
        }});

        tmpRow.sort((a, b) => {
        if (a.organization_cd !== b.organization_cd) {
            return a.organization_cd - b.organization_cd;
        } else if (a.department_cd !== b.department_cd) {
            return a.department_cd - b.department_cd;
        } else {
            if(sortKey === 'shift_table_seq'){
                return a.shift_table_seq - b.shift_table_seq;
            }else{
                const key = sortKey
                return a[key]?.localeCompare(b[key]); // 辞書順
            }
        }
        });
        setRows(tmpRow);
    }

    
    /**
     * column情報を作成する。
     */
    const createColumnData = () => {
        function formatDate(dateString) {
            const date = new Date(dateString);
            const month = date.getMonth() + 1; // 月は0から始まるため+1
            const day = date.getDate();
            return `${month}/${day}`;
          }

        const dates = getDatesBetween(serchCondition.target_date_from, serchCondition.target_date_to);

        let tmpColumns = [];
      
        dates.forEach(date => {
            let item ={};
          
            item["field"] = date;
            item["headerName"] = formatDate(date);
            item["width"] = 40;
            item["display"] = 'flex';
            item["headerAlign"] = 'center';
            item["align"] = 'center';
            item["justifyContent"] = 'center';
            item["valueGetter"] = (params) => (shiftHash[params.value.shift_type_cd] + (params.value.harf_holiday_shift_type_cd?("/" + shiftHash[params.value?.harf_holiday_shift_type_cd]):""));
            
            
            tmpColumns.push(item);
        });

        setColumns(tmpColumns);

    }


    /**
     * Styleの設定
     */
    const style = {
        tableRowStyle:{
            // padding:'0px',
            borderBottom: '2px solid black',
        },
        tableCellStyle:{
            minWidth:'30px',
            height:'1.5rem',
            padding:'0px',
            textAlign : 'center',
            overflow : 'hidden',
            borderBottom: 'none',
            fontSize:'0.7rem'
        },
        tableCellBorderBottom: (rowIndex) => ({
            borderBottom: rowIndex % elements.length === 0 ? '1px solid black' : 'none',
            // borderBottom: 'none',
        }),
        tableCellSticky: (left) => ({
            position: "sticky",
            zIndex: 10,
            left: left,
            backgroundColor: '#FFF',
        }),
    }

    // 配列の要素を入れ替える関数
    const swapArrayElements = (arr, index1, index2) => {
        const newArr = [...arr];
        const temp = newArr[index1];
        newArr[index1] = newArr[index2];
        newArr[index2] = temp;
        return newArr;
    };

    // 行を上下に移動する関数
    const handleMoveRow = (direction) => {
        if (selectedRowIndex === -1) {
            alert("行を選択してください。");
            return;
        }

        const newIndex = direction === 'up' ? selectedRowIndex - 1 : selectedRowIndex + 1;
        
        if (newIndex < 0 || newIndex >= rows.length) {
            alert(direction === 'up' ? "最上行です。" : "最下行です。");
            return;
        }

        // 行の順序を入れ替え
        const newRows = swapArrayElements(rows, selectedRowIndex, newIndex);
        setRows(newRows);
        setSelectedRowIndex(newIndex);
        
        // 変更フラグを設定
        setHasChanges(true);
    };

    // シフトテーブルシーケンスを更新する関数
    const updateShiftTableSeq = async (newRows) => {
        const newShiftTableSeq = newRows.map((row, index) => ({
            department_cd: row.department_cd,
            user_id: row.user_id,
            seq: index
        }));

        try {
            const response = await fetch("/api/update/shiftTableSeq", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newShiftTableSeq)
            });
            
            if (response.ok) {
                alert("データを保存しました。");
                setHasChanges(false);
            } else {
                alert("保存に失敗しました。");
            }
        } catch (error) {
            console.error("シフトテーブルシーケンスの更新に失敗しました:", error);
            alert("保存に失敗しました。");
        }
    };

    // 保存ボタンの処理
    const handleSave = () => {

        if(serchCondition.target_dept_cd === null){
            alert("部署を選択してください。");
            return;
        }

        if(rows)

        if (!hasChanges) {
            alert("変更がありません。");
            return;
        }
        updateShiftTableSeq(rows.filter(row=>row.department_cd === serchCondition.target_dept_cd));
    };

    // 行クリック時の処理
    const handleRowClick = (rowIndex) => {
        setSelectedRowIndex(rowIndex);
    };
    console.log(rows);

    return (
        <Box>
            <Box className="no-print">
                {isMobile?
                <SP_ShiftTableHeader
                    isMobile={isMobile}
                    Shift_msts={Shift_msts}
                    Department_msts={Department_msts}
                    serchCondition={serchCondition}
                    setSerchCondition={setSerchCondition}
                    getShiftTable={getShiftTable}
                    Login_user_info={Login_user_info}
                    isViewDept={isViewDept}
                    setIsViewDept={setIsViewDept}
                    isViewPaidHoliday={isViewPaidHoliday}
                    setIsViewPaidHoliday={setIsViewPaidHoliday}
                    TIME_PAID_HOLIDAY_FLG={TIME_PAID_HOLIDAY_FLG}
                    setRows={setRows}
                    sortKey={sortKey}
                    setSortKey={setSortKey}
                />:
                <ShiftTableHeader
                    isMobile={isMobile}
                    Shift_msts={Shift_msts}
                    Department_msts={Department_msts}
                    serchCondition={serchCondition}
                    setSerchCondition={setSerchCondition}
                    getShiftTable={getShiftTable}
                    Login_user_info={Login_user_info}
                    isViewDept={isViewDept}
                    setIsViewDept={setIsViewDept}
                    isViewPaidHoliday={isViewPaidHoliday}
                    setIsViewPaidHoliday={setIsViewPaidHoliday}
                    TIME_PAID_HOLIDAY_FLG={TIME_PAID_HOLIDAY_FLG}
                    setRows={setRows}
                    sortKey={sortKey}
                    setSortKey={setSortKey}
                />
                }
            </Box>
            
            {/* UP/DOWNボタンと保存ボタン */}
            {isMobile || Login_user_info.authority<20|| rows===null ? <></> :
            <Box className="no-print" sx={{ marginBottom: '10px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                <Button 
                    variant="contained" 
                    onClick={() => handleMoveRow('up')}
                    disabled={selectedRowIndex <= 0}
                >
                    UP
                </Button>
                <Button 
                    variant="contained" 
                    onClick={() => handleMoveRow('down')}
                    disabled={selectedRowIndex >= rows.length - 1 || selectedRowIndex === -1}
                >
                    DOWN
                </Button>
                <Button 
                    variant="contained" 
                    color="primary"
                    onClick={handleSave}
                    disabled={!hasChanges}
                    sx={{ marginLeft: '20px' }}
                >
                    保存
                </Button>
                {selectedRowIndex !== -1 && (
                    <Box sx={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
                        選択中: {rows[selectedRowIndex]?.user_name || ''} ({selectedRowIndex + 1}行目)
                    </Box>
                )}
                {hasChanges && (
                    <Box sx={{ marginLeft: '10px', color: 'orange', fontWeight: 'bold' }}>
                        ※ 変更があります。保存してください。
                    </Box>
                )}
            </Box>}

            {rows===null ? <Box className="loader">Loading...</Box> :
            <Box id="print-target" className="shift-print-root">
                <Box className="shift-print-header">
                    <Box className="shift-print-title">
                        勤務表　{deptHash[serchCondition.target_deptgr_cd]?.name || ''}　{deptHash[serchCondition.target_dept_cd]?.name || ''}　{serchCondition.target_date_from} ～ {serchCondition.target_date_to}
                    </Box>
                    <Box className="shift-print-datetime" ref={printDateTimeRef}>
                        印刷日時：
                    </Box>
                </Box>
                <TableContainer
                    className="shift-table-container"
                    component={Paper} 
                    style={{ 
                        maxHeight: isMobile?'70vh':'50vh',
                        overflow: 'auto' 
                    }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow sx={style.tableRowStyle}>
                                {isViewDept?<>
                                <TableCell 
                                    sx={{
                                        ...style.tableCellStyle,
                                        ...style.tableCellBorderBottom(elements.length),
                                        ...(isMobile?{}:{...style.tableCellSticky(0), zIndex: 30,}),
                                        minWidth:'180px'
                                    }}
                                    rowSpan={2}>
                                    施設
                                </TableCell>
                                <TableCell 
                                    sx={{
                                        ...style.tableCellStyle,
                                        ...style.tableCellBorderBottom(elements.length),
                                        ...(isMobile?{}:{...style.tableCellSticky(180), zIndex: 30,}),
                                        minWidth:'100px'
                                    }}
                                    rowSpan={2}>
                                    部署
                                </TableCell>
                                </>:<></>}
                                <TableCell 
                                    sx={{
                                        ...style.tableCellStyle,
                                        ...style.tableCellBorderBottom(elements.length),
                                        ...(isMobile?{}:{...style.tableCellSticky(280-(isViewDept?0:280)), zIndex: 30,}),
                                        minWidth:'100px'
                                    }}
                                    rowSpan={2}>
                                    職員番号
                                </TableCell>
                                <TableCell 
                                    sx={{
                                        ...style.tableCellStyle,
                                        ...style.tableCellBorderBottom(elements.length),
                                        ...(isMobile?{}:{...style.tableCellSticky(380-(isViewDept?0:280)), zIndex: 30,}),
                                        borderRight:'1px solid gray',
                                        marginRight:5,
                                        minWidth:'200px'
                                    }}
                                    rowSpan={2}>
                                    氏名
                                </TableCell>
                                <TableCell 
                                    sx={{
                                        ...style.tableCellStyle,
                                        ...style.tableCellBorderBottom(elements.length),
                                        ...(isMobile?{}:{...style.tableCellSticky(380-(isViewDept?0:280)), zIndex: 30,}),
                                        borderRight:'1px solid gray',
                                        marginRight:5,
                                        minWidth:'40px'
                                    }}
                                    rowSpan={2}>
                                    公休
                                </TableCell>
                                <TableCell 
                                    sx={{
                                        ...style.tableCellStyle,
                                        ...style.tableCellBorderBottom(elements.length),
                                        ...(isMobile?{}:{...style.tableCellSticky(380-(isViewDept?0:280)), zIndex: 30,}),
                                        borderRight:'1px solid gray',
                                        marginRight:5,
                                        minWidth:'40px'
                                    }}
                                    rowSpan={2}>
                                    有休
                                </TableCell>
                                {columns.map((column,index)=>(
                                    <TableCell 
                                        key={`h1-${column.field}`}
                                        className="shift-date-cell"
                                        sx={{
                                            ...style.tableCellStyle,
                                            ...style.tableCellBorderBottom(1),
                                            ...commonFnc. getStyleForDate(column.field, holidays),
                                            ...isMobile?{}:{zIndex: 20,},
                                            top:0,
                                            }}>
                                        {column.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow sx={style.tableRowStyle}>
                                {columns.map((column,index)=>(
                                    <TableCell 
                                        key={`h2-${column.field}`}
                                        className="shift-date-cell"
                                        sx={{
                                            ...style.tableCellStyle,
                                            ...style.tableCellBorderBottom(elements.length),
                                            ...commonFnc.getStyleForDate(column.field, holidays),
                                            top:24,
                                            ...isMobile?{}:{zIndex: 20,},
                                            }}>
                                        {commonFnc.getDayOfWeek(column.field)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {rows.map((row,index)=>{
                            const isOwnUser = row.user_id === Login_user_info?.user_id;
                            return (
                            <TableBody
                                key={`${row.user_id}-${row.department_cd}-${index}`}
                                className={`shift-user-block${isOwnUser ? ' shift-own-user' : ''}`}
                            >
                                {elements.map((element, rowIndex)=>(
                                    <TableRow 
                                        key={`${row.user_id}-${element}`}
                                        sx={{
                                            ...style.tableRowStyle,
                                            backgroundColor: selectedRowIndex === index ? '#e3f2fd' : 'inherit',
                                            cursor: 'pointer'
                                        }} 
                                        hover
                                        onClick={() => handleRowClick(index)}
                                    >
                                        {rowIndex===0?<>
                                            {isViewDept?<>
                                            <TableCell 
                                                sx={{
                                                    ...style.tableCellStyle,
                                                    ...style.tableCellBorderBottom(rowIndex),
                                                    ...(isMobile?{}:style.tableCellSticky(0)),
                                                }} 
                                                rowSpan={elements.length}
                                            >
                                                {deptHash[row["organization_cd"]].name}
                                            </TableCell>
                                            <TableCell 
                                                sx={{
                                                    ...style.tableCellStyle,
                                                    ...style.tableCellBorderBottom(rowIndex),
                                                    ...(isMobile?{}:style.tableCellSticky(180)),
                                                }} 
                                                rowSpan={elements.length}
                                            >
                                                {deptHash[row["department_cd"]].name}
                                            </TableCell>
                                            </>:<></>}
                                            <TableCell 
                                                sx={{
                                                    ...style.tableCellStyle,
                                                    ...style.tableCellBorderBottom(rowIndex),
                                                    ...(isMobile?{}:style.tableCellSticky(280-(isViewDept?0:280))),
                                                }} 
                                                rowSpan={elements.length}
                                            >
                                                {row["user_id"]}
                                            </TableCell>
                                            <TableCell 
                                                sx={{
                                                    ...style.tableCellStyle,
                                                    ...style.tableCellBorderBottom(rowIndex),
                                                    ...(isMobile?{}:style.tableCellSticky(380-(isViewDept?0:280))),
                                                    borderRight:'1px solid gray',
                                                    marginRight:5
                                                }} 
                                                rowSpan={elements.length}
                                            >
                                                {row["user_name"]}
                                            </TableCell>
                                            <TableCell 
                                                sx={{
                                                    ...style.tableCellStyle,
                                                    ...style.tableCellBorderBottom(rowIndex),
                                                    ...(isMobile?{}:style.tableCellSticky(380-(isViewDept?0:280))),
                                                    borderRight:'1px solid gray',
                                                    marginRight:5
                                                }} 
                                                rowSpan={elements.length}
                                            >
                                                {row["total_public_holiday_time"]/8}
                                            </TableCell>
                                            <TableCell 
                                                sx={{
                                                    ...style.tableCellStyle,
                                                    ...style.tableCellBorderBottom(rowIndex),
                                                    ...(isMobile?{}:style.tableCellSticky(380-(isViewDept?0:280))),
                                                    borderRight:'1px solid gray',
                                                    marginRight:5
                                                }} 
                                                rowSpan={elements.length}
                                            >
                                                {row["total_paid_holiday_time"]/8}
                                            </TableCell>
                                        </>:<></>}
                                        {columns.map((column,columnIndex)=>{
                                            const shiftBg = row[column.field] ? shiftStyleList[row[column.field][element]]?.backgroundColor : undefined;
                                            const shiftColor = row[column.field] ? shiftStyleList[row[column.field][element]]?.color : undefined;
                                            const hasShiftColor = Boolean(shiftBg);
                                            return row[column.field]?
                                            <TableCell
                                                key={`${row.user_id}-${column.field}-${element}`}
                                                className={`shift-date-cell${hasShiftColor ? ' shift-colored-cell' : ''}`}
                                                sx={{
                                                ...style.tableCellStyle,
                                                color:shiftColor,
                                                backgroundColor:shiftBg,
                                                borderBottom:rowIndex===elements.length-1?'1px solid black':'none',
                                                }}>
                                                    <Box sx={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                                                        {shiftHash[row[column.field][element]]}
                                                        {
                                                            element==='shift_type_cd'&&row[column.field]['shift_type_cd_change_flg'] ? <ChangeShiftPriorityHighIcon fontSize='0.7rem' margin='2px'/> :<></>
                                                        }
                                                    </Box>
                                            </TableCell>
                                            :<TableCell
                                                key={`${row.user_id}-${column.field}-${element}-empty`}
                                                className="shift-date-cell"
                                                sx={{borderBottom:rowIndex===elements.length-1?'1px solid black':'none',}}
                                            ></TableCell>
                                        })}
                                    </TableRow>
                                ))}
                            </TableBody>
                            );
                        })}
                    </Table>
                </TableContainer>
            </Box>}
        </Box>
    );
}

export default ShiftTableContents;